import React__default from 'react';
import { useApplicationContext, Application } from '../../../containers/ApplicationContext/index.js';
import MessageBubble from '../../MessageBubble/index.js';
import MessageBubbleText from '../../MessageBubbleText/index.js';
import { ConsumerRichCardEvents } from '../../../containers/RichCardEventEmitter/ConsumerEventData/index.js';
import { useRichCardEventEmitter } from '../../../containers/RichCardEventEmitter/index.js';
import { newCustomCuratedOrderRichCard } from '../../../services/richCardFactory.js';
import HeroWithImage from '../components/HeroWithImage/index.js';
import CallToAction from '../components/CallToAction/index.js';
import { CustomExpertCuratedOrderMessageComponent } from './CustomExpertCuratedOrderMessage.generated.js';
import RulerPencilIcon from './ruler-pencil.svg.js';
import PlusIcon from './plus.svg.js';
import styles from './styles.css.js';

var CustomExpertCuratedOrderMessage = function CustomExpertCuratedOrderMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var application = useApplicationContext().application;
  var richCardEventEmitter = useRichCardEventEmitter();
  var richCard = newCustomCuratedOrderRichCard(message);
  var expertCuratedOrderId = richCard.expertCuratedOrderId;
  return React__default.createElement(CustomExpertCuratedOrderMessageComponent, {
    variables: {
      id: expertCuratedOrderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.expertCuratedOrder) {
      var _b = data.expertCuratedOrder,
          lead = _b.lead,
          items = _b.items,
          category = _b.category,
          id_1 = _b.order.id;
      var expert = lead.expert;
      var banner = category === null || category === void 0 ? void 0 : category.contentAssets.bannerImages[0];
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
        heroLabel: React__default.createElement(React__default.Fragment, null, React__default.createElement(RulerPencilIcon, {
          width: 48,
          height: 48,
          className: styles.icon
        }), React__default.createElement("div", null, expert.shortName + "'s custom order"))
      }), React__default.createElement("div", {
        className: styles.caption
      }, React__default.createElement(PlusIcon, {
        className: styles.plusIcon
      }), " ", items.length, ' ', items.length === 1 ? 'item' : 'items', " in order"), application === Application.CONSUMER ? React__default.createElement(CallToAction, {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: ConsumerRichCardEvents.VIEW_ORDER,
            orderId: id_1
          });
        }
      }, "View custom order") : React__default.createElement("button", {
        className: styles.cta
      }, "View custom order"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

CustomExpertCuratedOrderMessage.handlesMessage = function (message) {
  return !!newCustomCuratedOrderRichCard(message);
};

export default CustomExpertCuratedOrderMessage;
//# sourceMappingURL=index.js.map
